import React from 'react';

export default {
  fields: [
    {
      type: 'text',
      name: 'email',
      disabled: true,
      props: {
        required: false,
        label: (
          <p>
            Current Email Address
          </p>
        )
      }
    },
    {
      type: 'text',
      name: 'newEmail',
      props: {
        required: true,
        label: (
          <p>
            <i className='asterisk icon inline' />New Email Address
          </p>
        )
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/ChangeEmailModal/changeEmailFormConfig.jsx